/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddEmergencyContactAuthIdsRequest
 */
export interface AddEmergencyContactAuthIdsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddEmergencyContactAuthIdsRequest
     */
    auth_ids: Array<string>;
}

/**
 * Check if a given object implements the AddEmergencyContactAuthIdsRequest interface.
 */
export function instanceOfAddEmergencyContactAuthIdsRequest(value: object): value is AddEmergencyContactAuthIdsRequest {
    if (!('auth_ids' in value) || value['auth_ids'] === undefined) return false;
    return true;
}

export function AddEmergencyContactAuthIdsRequestFromJSON(json: any): AddEmergencyContactAuthIdsRequest {
    return AddEmergencyContactAuthIdsRequestFromJSONTyped(json, false);
}

export function AddEmergencyContactAuthIdsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddEmergencyContactAuthIdsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'auth_ids': json['auth_ids'],
    };
}

export function AddEmergencyContactAuthIdsRequestToJSON(json: any): AddEmergencyContactAuthIdsRequest {
    return AddEmergencyContactAuthIdsRequestToJSONTyped(json, false);
}

export function AddEmergencyContactAuthIdsRequestToJSONTyped(value?: AddEmergencyContactAuthIdsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'auth_ids': value['auth_ids'],
    };
}

